module.exports = __webpack_public_path__ + "img/recruittext-md.4f288810.png";